import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
// import * as _ from 'lodash'
// import CustomCSSInput from './CustomCSSInput'
import StylePresetsMain from './StylePresetsMain'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

class CustomCSSView extends Component {

  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { field, app } = this.props
    return (
      <Container>
        <StylePresetsMain
          field={field}
          app={app}
        />
        {/*removing custom css input for now*/}
        {/*<CustomCSSInput*/}
        {/*field={field}*/}
        {/*app={app}*/}
        {/*/>*/}
      </Container>
    )
  }
}

CustomCSSView.propTypes = {
  field: PropTypes.object.isRequired,
  // location: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  location: state.location
})

export default connect(mapStateToProps)(CustomCSSView)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/CustomCSSView.js